import React, { Component, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import moment from 'moment';
import { store } from 'react-notifications-component';

import BackArrow from '../../Images/arrow-left.svg';
import Modaltwofa from '../2fa';

import Backend from '../../Backend';
import Connection from '../../Calls';

export default function ConfirmPayment (props){
  const date = new Date();
  const values = ['coin','wallet_alias','mxn_price','crypto_price']
  const valuesSummary=['reference']
  const { services, ecomm, General } = props.traductions
  const pricesSocket = useRef(null);
  const [USDprice, setUSDprice] = useState({})
  const [show, setShow] = useState(false)
  const [password, setPassword] = useState('')
  const [twoFa, setTwoFa] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ConectSocketPrice()
    checkTwoFa()
    return () => {
      if(pricesSocket.current != null)
      pricesSocket.current.close(1000, "Work complete");
    }
  }, [])

  const checkTwoFa = () => {
    const self = this
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;

    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.Check2FA(localStorage.getItem('email'),localStorage.getItem('token'), response.payload.r01, response=>{
          if(response.status.code === "0"){
            if(response.payload.status == 'enabled')
              setTwoFa(true)
          }
        })
    })
  }

  const addNotification = (status,msg,type) => {
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true
      }
    });
  }

  const TowFAConfirm = (code) => {
    if(code =='cancel')
      setShowModal(false)
    else {
      setShowModal(false)
      setTimeout(() => {
        Pay(code)
      }, 1000);
    }
  }

  const ConectSocketPrice = () => {

    // if(pricesSocket.current != null ){
    //     pricesSocket.current.close(1000, "Work complete");
    //     pricesSocket.current == null
    // }

    var wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    var wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
    pricesSocket.current = new WebSocket(wsProtocol + "//" + wsHost);

    pricesSocket.current.onopen = function(e) {
      if(pricesSocket.current) pricesSocket.current.send('GNTWIREBIT');
    };

    pricesSocket.current.onmessage = function(event) {
      if(event.data){
        var object = JSON.parse(event.data);
        let Pair = 'USDMXN'
        if (object[Pair] != USDprice)
          setUSDprice(object[Pair])
      }
    };
  }

  const renderValues = () =>{
    return values.map(item => {
      return(
        <div className="flex space-between" style={{marginBottom:5}}>
          <div>
            {services[item]}
          </div>
          <div className='gray-text'>
            {(item=='crypto_price')
              ?`${getPriceCoin()} ${props['coin'].toUpperCase()}`
              :props[item]}
          </div>
        </div>
      )
    });
  }

  const renderValuesSummary = () =>{
    return valuesSummary.map(item => {

      return(
        <div className="flex space-between" style={{marginBottom:5}}>
          <div>
            {props.label_service}
          </div>
          <div className='gray-text'>
            {props[item]}
          </div>
        </div>
      )
    });
  }

  const renderDate = () => {
    let date=moment().utc()
    return `${date.format('D')} / ${General.months[date.get('month')+1]} / ${date.get('year')}`
  }

  const renderModalPass = () => {
    return(
      <Modal  show={show} onHide={()=>setShow(false)} centered>
      <Modal.Body>
        <p className="dark-text normal-dms font-17 bmargin0" style={{marginBottom:'1em'}} >{services.summary.walletPass}: {props['wallet_alias']}</p>

        <Form.Control
          type="password"
          placeholder={services.summary.walletPass}
          className="input-services"
          value={password}
          onChange={(pass) => { setPassword(pass.target.value ) }}
        />

        <button
          className={'services_continue_button'}
          onClick={()=>(twoFa)?setShowModal(true):Pay()}
          style={{marginTop:'2em'}}
          disabled={loading ||password==''}
          >
          {services.summary.confirmPass}
        </button>
      </Modal.Body>
    </Modal>
    )
  }

  const getPriceCoin = () => {
    return Number(Number(  Number(props['amount']) / USDprice.bid || 0   ) /  Number(props['crypto_price'])).toFixed(8)
  }

  const Pay = (twoFaCode) => {
    setLoading(true)
    const self = this
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;

    let whiskas = Connection.RThzHrsb(password);
    let combination2 = Connection.RThzHrsb("XWBX203")

    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var charly = response.payload.r01;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, response => {
        let info ={
          coin: props['coin'],
          amount: getPriceCoin(),
          id_service:props['service'].id,
          service_amount: props['amount'],
          Reference:props['reference'],
          from_wallet: props['selectedWallet'].id_wallet,
          key:response.payload.r03 //wallet passwor
        }

        Backend.transfer_service_payment(info, twoFaCode, charly, response=>{
          if(response.status.code === "0"){
            setShow(false)
            addNotification("Success!","The service was paid correctly","success");
            props.goReceipt(`${getPriceCoin()} ${props['coin'].toUpperCase()}`)
          }else{
            addNotification("Error!",response.status.description,"danger");
          }
          setLoading(false)
        })

      })
    })
  }

  return(
    <Container className="services_container" style={{ paddingLeft: 10, paddingRight: 10 }}>
      <div>
        <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10, display:'flex', alignItems:'center'}} onClick={()=>props.goBack()}>
          <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
          <p className='dark-text medium-dms text-25' style={{margin:0}}>{ecomm.goBack}</p>
        </div>
      </div>

      <div className='container-transactions'>

        <div className='flex space-between bmargin10'>
          {
            (props.service && props.service.logo == 'NO LOGO')
            ? props.service.name
            : <Image src={'data:image/svg+xml;base64,'+props.service.logo} style={{ height:40 }} />
          }
          <div className='gray-text'>{renderDate()}</div>
        </div>

        <p className='blue-text medium-dms'>{services.summary.title_1}</p>
        {renderValuesSummary()}
        <div style={{width:'100%', height:1, backgroundColor:'#D6D6D6', marginTop:'1em', marginBottom:'1em'}}/>
        <p className='blue-text medium-dms'>{services.summary.title_2}</p>
        {renderValues()}

        <div>
            <button
              className={'services_continue_button'}
              onClick={()=>setShow(true)}
              disabled={loading}
              >
              {services.summary.confirm}
            </button>
          </div>

      </div>
      {renderModalPass()}
      <Modaltwofa modal showModalTwofa={showModal} TowFAConfirm={TowFAConfirm} traductions={props.traductions}/>
    </Container>
  )
}
